import api, { apiPrefix } from './Api';
import {
  SlidingBanner,
  slidingBannerFromResponse,
} from '../interfaces/SlidingBanner/SlidingBanner';

const slidingBannerApiPrefix = `${apiPrefix}/sliding-banners`;

export const getSlidingBanners = async (): Promise<SlidingBanner[]> => {
  const response = await api.get(slidingBannerApiPrefix);

  return (response.data?.data ?? []).map(slidingBannerFromResponse);
};
